import type { TDocumentType, TImportantCargoDocumentFlags } from 'api/swagger';

export interface IImportantCargoDocumentFlags {
  documents: TImportantCargoDocumentFlags;
}

export const documentTypeMapping: Record<keyof TImportantCargoDocumentFlags, TDocumentType> = {
  withEx1: 'ex1',
  withCds: 'cds',
  withT1: 't1',
  withEns: 'ens',
  withBarcode: 'barcode',
};
